import React, { useState } from 'react';
import './EnhancedFAQ.css';

const EnhancedFAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'How accurate are the processing time estimates?',
      answer: "Our processing tool shows illustrative planning ranges and dated official queue snapshots. Check the stated visa office and source date. These are not individual predictions or official deadlines.",
      category: 'accuracy'
    },
    {
      question: 'What if my visa is refused?',
      answer: "If a refusal appears for your tracked reference in an official NDVO publication, it is handled by the decision-alert system. Read the decision letter and its instructions, including any appeal deadline. Our resources provide general guidance.",
      category: 'refusal',
      link: '/resources/ireland-visa-appeal'
    },
    {
      question: 'Can I track multiple applications?',
      answer: "Checkout registers one eight-digit visa reference. If you need alerts for another application, contact support from your purchase email so we can confirm its monitoring setup. The purchase includes all 13 premium planning tools.",
      category: 'features'
    },
    {
      question: 'Do you send alerts for both approvals AND refusals?',
      answer: "We monitor approvals and refusals published in the official NDVO decision list. The service does not provide unpublished internal case updates.",
      category: 'alerts'
    },
    {
      question: 'How fast are the alerts compared to manual checking?',
      answer: "We check for official publications automatically during the configured monitoring window. Alert timing depends on publication, processing and provider delivery; we cannot promise an exact arrival time.",
      category: 'speed'
    },
    {
      question: 'Is this an official Irish government service?',
      answer: "No. We are an independent service using publicly available official NDVO decisions. We are not affiliated with the Government of Ireland, Irish Immigration or VFS Global.",
      category: 'official'
    },
    {
      question: 'What happens after I upgrade to premium?',
      answer: "After payment verification, premium access and monitoring are enabled for your registered references. We send a welcome email. Browser alerts require separate permission and enrollment on each device; email monitoring does not depend on browser enrollment.",
      category: 'upgrade'
    },
    {
      question: 'Can I get a refund if I\'m not satisfied?',
      answer: "Premium is a one-time, non-refundable purchase. Monitoring setup and tool access begin after payment verification, so we do not offer change-of-mind or unused-access refunds. For billing errors or service problems, contact visahelp@irelandvisatracker.in. Our refund policy explains the details and preserves rights required by law.",
      category: 'refund'
    },
    {
      question: 'How do web push notifications work?',
      answer: "After upgrading, you can enable browser notifications on a supported device. Browser permission, an active subscription and provider delivery are required. Keep email alerts enabled as your primary channel.",
      category: 'notifications'
    },
    {
      question: 'Do you store my personal information?',
      answer: "We store account details, registered visa references, payment metadata and delivery records needed to operate the service. Browser alerts also require subscription details. Read our privacy and data-deletion pages for more information.",
      category: 'privacy'
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="enhanced-faq-section">
      <div className="faq-header">
        <h2>Frequently Asked Questions</h2>
        <p className="faq-subtitle">
          Everything you need to know about tracking your Ireland visa application
        </p>
      </div>

      <div className="faq-container">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className={`faq-item ${openIndex === index ? 'open' : ''}`}
          >
            <button
              className="faq-question"
              onClick={() => toggleFAQ(index)}
              aria-expanded={openIndex === index}
            >
              <span className="faq-question-text">{faq.question}</span>
              <span className="question-icon">
                {openIndex === index ? '−' : '+'}
              </span>
            </button>
            <div className={`faq-answer ${openIndex === index ? 'visible' : ''}`}>
              <p>{faq.answer}</p>
              {faq.link && (
                <a href={faq.link} className="faq-link">
                  Learn more about visa appeals →
                </a>
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="faq-cta">
        <h3>Still have questions?</h3>
        <p>Contact us at <a href="mailto:visahelp@irelandvisatracker.in">visahelp@irelandvisatracker.in</a></p>
      </div>
    </div>
  );
};

export default EnhancedFAQ;
